import {
  DesiredSettingValue,
  DesiredSettingValueKind,
} from '@crossnokaye/typescript-sdk/models/components';

import { SettingAction, SettingActionValueKind } from '@repo/sdk/models/components';

import { getDesiredSettingValueKind } from '@/helpers/settings';
import { useUpdateSettings } from '@/hooks/query-hooks/settings';
import { useCurrentFacility } from '@/hooks/use-current-facility';

import { makeControlledDeviceSettingValue } from './helpers';

export const useHandleUpdateSettings = () => {
  const { organizationId: orgId, agentId } = useCurrentFacility();
  const { mutateAsync: updateSettings, isPending } = useUpdateSettings({
    orgId,
    agentId,
  });

  const handleUpdateSettings = async (settingActions: SettingAction[]) => {
    if (settingActions) {
      const updatedSettings: DesiredSettingValue[] = settingActions.map(
        (settingAction: SettingAction): DesiredSettingValue => {
          const kind: DesiredSettingValueKind = getDesiredSettingValueKind(
            settingAction.valueKind as SettingActionValueKind
          );

          return {
            settingId: settingAction.id,
            kind: kind,
            desiredValue: makeControlledDeviceSettingValue(settingAction),
          };
        }
      );

      try {
        await updateSettings(updatedSettings);
      } catch (error) {
        console.error(error);
      }
    }
  };

  return { handleUpdateSettings, isPending };
};
